import React, { useMemo } from 'react';
import Alert from '@minecraft.alert';
import { useLogout, useUserContext } from '@blocs.auth';
import { useTranslation } from '@blocs.i18n';
import { useLocation } from 'react-router';
import { PaywallLocation } from '@blocs.paywall';
import { BasicContainer } from '@minecraft.atoms';
import Nav from './Nav';

export enum ERROR_CODES {
  INVALID_PLAN,
}

export type HeaderProps = {
  hideNavigation: boolean;
  showLogoutWhenHiddenNav?: boolean;
  location?: PaywallLocation;
};

const Header = ({ hideNavigation, showLogoutWhenHiddenNav, location }: HeaderProps): JSX.Element => {
  const { myAccount } = useUserContext();
  const { t } = useTranslation();
  const { state, pathname } = useLocation<{ error?: ERROR_CODES }>();
  const [logout] = useLogout(false);
  const globalError = useMemo(() => {
    if (state?.error === ERROR_CODES.INVALID_PLAN) {
      return t('talent:billing.planPurchase.invalid');
    }

    if (state?.error) {
      return t('common:globalError.genericUnexpected');
    }

    return undefined;
  }, [state?.error, t]);

  if (!myAccount && !hideNavigation) {
    // this should not happen, when running the apps live b/c this
    // should always be inside the <AuthenticatedRoute /> which will
    // not render its children if the myAccount data isn't available
    return null;
  }

  return (
    <BasicContainer bgColor="card" w="full" borderPlacement="bottom">
      {!!globalError && (
        <Alert sticky type="error" size="fullWidth">
          {globalError}
        </Alert>
      )}
      {/* the /loginAdmin route is not used anymore, we should redirect it to the default route and remove any related code */}
      {!pathname.includes('/loginAdmin') && (
        <div key="main-nav">
          <Nav
            hideNavigation={hideNavigation}
            logout={logout}
            showLogoutWhenHiddenNav={showLogoutWhenHiddenNav}
            location={location}
          />
        </div>
      )}
    </BasicContainer>
  );
};

export default Header;
